import {
  CheckOutlined,
  GlobalOutlined,
  QuestionCircleOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { AvatarDropdown, useLocale } from '@zhiyue/core';
import React from 'react';

const locales = [
  ['zh-CN', '简体中文'],
  ['zh-TW', '繁體中文'],
  ['en-US', 'English'],
  ['ja-JP', '日本語'],
];

const HeaderUserMenu: React.FC<React.ComponentProps<typeof AvatarDropdown>> = (
  props,
) => {
  const { locale, setLocale } = useLocale();
  return (
    <AvatarDropdown
      {...props}
      mergeDefaultItems
      items={[
        {
          key: 'help',
          label: '帮助文档',
          icon: <QuestionCircleOutlined />,
          href: 'https://docs.shanhuyun.cn/',
          target: '_blank',
        },
        { type: 'divider' },
        ...locales.map(([key, label]) => ({
          key: `language:${key}`,
          label: `语言 · ${label}`,
          icon: key === locale ? <CheckOutlined /> : <GlobalOutlined />,
        })),
      ]}
      onAction={(key) => {
        if (key.startsWith('language:'))
          setLocale(key.slice('language:'.length));
      }}
    >
      <button type="button" className="app-header-user" aria-label="用户菜单">
        <UserOutlined />
      </button>
    </AvatarDropdown>
  );
};

export default HeaderUserMenu;
